import { eq } from "drizzle-orm";
import { type PowerSyncDrizzleDB, user } from "@space/powersync";
import { VISITOR_ID } from "../constants/common";

export interface UserPreferences {
  locale: string | null;
  global_theme_id: string | null;
  is_blur: number | null;
  follow_device_theme: number | null;
  font_family: string | null;
}

/**
 * Shared Drizzle query builder for User preferences.
 */
export function getUserPreferencesQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select({
      locale: user.locale,
      global_theme_id: user.global_theme_id,
      is_blur: user.is_blur,
      follow_device_theme: user.follow_device_theme,
      font_family: user.font_family,
    })
    .from(user)
    .where(eq(user.id, userId))
    .limit(1);
}

/**
 * Consentimiento de leaderboard (opt-in de privacidad) del usuario.
 */
export function getUserLeaderboardOptInQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select({
      leaderboard_opt_in: user.leaderboard_opt_in,
    })
    .from(user)
    .where(eq(user.id, userId))
    .limit(1);
}

/**
 * Shared Drizzle query builder for User locale.
 */
export function getUserLocaleQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select({
      locale: user.locale,
    })
    .from(user)
    .where(eq(user.id, userId))
    .limit(1);
}

/**
 * Shared Drizzle query builder for User font family preference.
 */
export function getUserFontFamilyQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select({
      font_family: user.font_family,
    })
    .from(user)
    .where(eq(user.id, userId))
    .limit(1);
}

/**
 * Shared Drizzle query builder for User theme settings.
 */
export function getUserThemeSettingsQuery(db: PowerSyncDrizzleDB, userId: string) {
  const query = db
    .select({
      global_theme_id: user.global_theme_id,
      is_blur: user.is_blur,
      follow_device_theme: user.follow_device_theme,
    })
    .from(user);

  if (userId !== VISITOR_ID) {
    return query.where(eq(user.id, userId)).limit(1);
  }

  return query.limit(1);
}
